import { encodeLoad, decodeLoad } from '@/lib/base64.js'

import { CreateHypatiaJWE } from '@/lib/createJWT.js'

import { adminStore } from '@/stores/adminstore.js'

import { toast } from 'vue3-toastify'
import i18n from '@/i18n/i18n-setup.js'
import jwt from 'jsonwebtoken'

const { t } = i18n.global

export const userActions = {
  setTest(text) {
    console.log('set TEST got called (%s)', text)
    this.test = text
  },
  setLoggedIn(status) {
    this.loggedin = status
  },
  setDisplayName(name) {
    this.displayname = name
  },
  setNotRegistered(registered) {
    this.notregistered = registered
  },
  setPrimaryUserSelected(selected) {
    this.primaryselected = selected
  },
  setSecondaryUser(payload) {
    this.secondaryuser = payload
  },
  sjekkKardeUser() {
    let sUserEmail = this.email
    console.log('SUSER (%s)', sUserEmail)
    let domene = sUserEmail.split('@')
    console.log('domene (%s)', domene[1])
    if (domene[1] === 'karde.no' && domene.length <= 2) {
      return true
    } else {
      return false
    }
  },
  sjekkAdminUsers() {
    let sUserEmail = this.email
    console.log('Admin User (%s)', sUserEmail)
    if (this.adminUsers.includes(sUserEmail)) {
      return true
    } else {
      return false
    }
  },
  async loginProviderLogin(payload) {
    console.log('loginProviderLogin got called !')
    console.log(payload)
    let { adminStore } = await import('@/stores/adminstore.js')
    let aStore = adminStore()
    return new Promise((resolve, reject) => {
      aStore.accesstoken =
        payload.bearerToken || payload.idToken || payload.accessToken
      aStore.accesstokenexpires =
        payload.expires || payload.exp || payload.idTokenClaims.exp
      aStore.idtoken = payload.id_token || payload.idToken
      // localStorage.setItem('tokenexpire', payload.expires)
      this.displayname = payload.userName || payload.name
      //      this.userid = payload.userid
      this.email = payload.email || payload.username
      this.affiliation = 'KardeMEMAS'
      payload.email = this.email
      payload.userid = this.userid || payload.userid // || payload.username
      payload.username = this.username || payload.username
      payload.affiliation = this.affiliation
      payload.accesstoken = aStore.accesstoken
      // context.dispatch('fixServerURL')
      payload.encodedAccessToken = payload.bearerToken
      // payload.eduPersonAffiliation = 'KardeMEMAS'
      // let publicKey = context.getters.getPublicKey // for client use
      //    let privateKey = context.getters.getPrivateKey // for serveruse !
      createJwtTokenForClient(payload)
        .then((result) => {
          console.info('createJwtTokenForClient returned / JWTTOKEN ')
          console.log(result)
          // last part of the token is the secret key..
          // context.commit('setAcessToken', result.accessToken)
          aStore.accesstoken = result

          aStore.serveraccesstoken = result.accessToken
          this.publickey = result.publicKey
          this.appsecret = result.secret
          aStore.accesstokenexpires = payload.expires
          this.loggedin = true
          //  context.dispatch('setMunicipalityNIN', norEduOrgNin.municipalityNorEduOrgNin)
          //  context.dispatch('setSchoolNIN', norEduOrgNin.schoolNorEduOrgNin)
          resolve({
            success: true,
            error: false
          })
        })
        .catch((error) => {
          console.error(
            '*** ERROR *** createJWT Token For Client had some problems : ' +
              error
          )
          reject(
            new Error(
              '*** ERROR *** createJWT Token For Client had some problems : ' +
                error
            )
          )
        })
    })
  },
  /* Session returned by memas-server after it verified a Google/Microsoft login:
     {sid, secret, publicKey, expires, user: {provider, email, name}}. The client token
     must carry the verified email - the server rejects any other. */
  async loginVerifiedSession(session) {
    let aStore = adminStore()
    let { email, name } = session.user
    this.displayname = name
    this.email = email
    this.affiliation = 'KardeMEMAS'
    let result = await signClientToken(
      {
        userid: email,
        username: email,
        affiliation: this.affiliation,
        email: email
      },
      session
    )
    aStore.accesstoken = result
    aStore.idtoken = ''
    aStore.serveraccesstoken = result.accessToken
    aStore.accesstokenexpires = session.expires
    this.publickey = result.publicKey
    this.appsecret = result.secret
    this.loggedin = true
    return { success: true, error: false }
  },
  async findSecondaryUser(payload) {
    console.log('findSecondary user got called (%j)', payload)
    let { adminStore } = await import('@/stores/adminstore.js')
    let aStore = adminStore()
    /*
    let load = `{
        query(func: eq(su_email,"${email}")) @cascade {
           uid
           su_email
           su_displayName
        }
    } `
     */
    let load = {
      username: payload.username,
      name: payload.name
    }
    //  this.email = payload.username
    let pLoad = {
      mutate: encodeLoad(JSON.stringify(load)),
      gogl: true
    }
    return new Promise((resolve) => {
      aStore
        .postHTTP(
          'memasadmin/findSecondaryUserQreateNew/findLoggedInUserNew',
          pLoad
        )
        .then((response) => {
          console.log('Find secondary user respons (%j)', response)
          let responseDgraphResult = response.data.dgraphresult || {}
          this.userid = responseDgraphResult.uid
          if (responseDgraphResult.newuser) {
            console.log('New user created')
            // populate the store so the fresh node (incl. invoice
            // co-secondaryUser flags) is available to the components
            this.getSecondaryUser().then(() => {
              resolve({
                success: true,
                newuser: true,
                uid: responseDgraphResult.uid
              })
            })
          } else {
            // We have user - get rest of data...
            // this.setSecondaryUser(response.data.dgraphresult.data)
            this.getSecondaryUser().then((result) => {
              if (result.success) {
                resolve({ success: true, data: result.data })
              } else {
                resolve({ success: false, error: true, errMsg: result.errMsg })
              }
            })
          }
        })
        .catch((err) => {
          console.log('** ERROR ** Find secondary user respons (%j)', err)
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // then
    }) // promise
  },
  async getSecondaryUser() {
    console.log('getSecondary user got called (%s)', this.email)
    let { adminStore } = await import('@/stores/adminstore.js')
    let aStore = adminStore()
    let load = `{
        query(func: eq(su_email,"${this.email}")) {
           uid
           su_name
           su_email
           su_picture
           su_displayName
           su_created
           su_address
           su_postcode
           su_place
           su_country
           su_phone
           su_skype
           su_agrementtype
           su_relation_type
           su_emergency_contact
           su_emergency_phone
           su_preferences
           su_vippsagreementid
           su_vippsagreementstatus
           su_vippsnextchargedue
           su_subscriptionplan
           su_minprimaryusers
           su_maxprimaryusers
           su_minsecondaryusers
           su_maxsecondaryusers
           su_firstinvoicedate
           su_cosecondaryuser
           su_mastersecondaryuser {
             uid
             su_email
           }
           su_hasPrimaryUser {
            uid
           }
        }
    }`
    let pLoad = {
      query: encodeLoad(load),
      gogl: true
    }
    return new Promise((resolve) => {
      aStore
        .postHTTP('dgraph-api/dquery/getSecondaryUser', pLoad)
        .then((response) => {
          console.log('GET secondary user respons (%j)', response.data)
          this.secondaryuser = response.data.dgraphresult[0]
          this.setEngageUser(response.data.dgraphresult[0])
          resolve({ success: true, data: response.data.dgraphresult[0] })
        }) // then
        .catch((err) => {
          console.log('** ERROR ** Find secondary user respons (%j)', err)
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // catch
    }) // promise
  },
  async getAllSecondaryUsers() {
    console.log('getSecondary user got called (%s)', this.email)
    let { adminStore } = await import('@/stores/adminstore.js')
    return new Promise((resolve) => {
      let aStore = adminStore()
      let load = `{
        query(func: has(su_email)) {
           uid
           su_name
           su_email
           su_agrementtype
        }
    } `
      let pLoad = {
        query: encodeLoad(load),
        gogl: true
      }
      aStore
        .postHTTP('dgraph-api/dquery/getAllSecondaryUser', pLoad)
        .then((response) => {
          console.log('Find secondary user respons (%j)', response.data)
          resolve({ success: true, data: response.data.dgraphresult })
        }) // then
        .catch((err) => {
          console.log('** ERROR ** Find secondary user respons (%j)', err)
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // catch
    }) // promise
  },
  async deleteSecondaryUser(payload) {
    console.log('deleteSecondary user got called (%j)', payload)
    let { adminStore } = await import('@/stores/adminstore.js')
    return new Promise((resolve) => {
      let aStore = adminStore()
      let load = `<${payload.uid}> * * . \n`
      let pLoad = {
        mutate: encodeLoad(load),
        gogl: true
      }
      aStore
        .postHTTP('dgraph-api/ddeletenquad/secondaryuser', pLoad)
        .then((result) => {
          console.log('deleteSecondary returned ', result)
          resolve({ success: true, data: result })
        })
        .catch((err) => {
          console.log('** ERROR ** deleteSecondary returned ', err)
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // then
    }) // promise
  },
  /* Adds an email to this invoice master's allowed co-secondaryUsers list.
     The cap (su_maxsecondaryusers) is checked by the caller. */
  async addCoSecondaryUser(email) {
    console.log('addCoSecondaryUser got called (%s)', email)
    let { adminStore } = await import('@/stores/adminstore.js')
    return new Promise((resolve) => {
      let aStore = adminStore()
      let load = `<${this.secondaryuser.uid}> <su_cosecondaryuser> "${email}" . \n`
      let pLoad = {
        mutate: encodeLoad(load),
        gogl: true
      }
      aStore
        .postHTTP('dgraph-api/dmutatenquad/cosecondaryuser', pLoad)
        .then((result) => {
          console.log('addCoSecondaryUser respons (%j)', result)
          resolve({ success: true, data: result })
        })
        .catch((err) => {
          console.log('** ERROR ** addCoSecondaryUser respons (%j)', err)
          aStore.checkError(err)
          resolve({ success: false, error: true, errMsg: err })
        })
    }) // promise
  },
  async removeCoSecondaryUser(email) {
    console.log('removeCoSecondaryUser got called (%s)', email)
    let { adminStore } = await import('@/stores/adminstore.js')
    return new Promise((resolve) => {
      let aStore = adminStore()
      let load = `<${this.secondaryuser.uid}> <su_cosecondaryuser> "${email}" . \n`
      let pLoad = {
        mutate: encodeLoad(load),
        gogl: true
      }
      aStore
        .postHTTP('dgraph-api/ddeletenquad/cosecondaryuser', pLoad)
        .then((result) => {
          console.log('removeCoSecondaryUser respons (%j)', result)
          resolve({ success: true, data: result })
        })
        .catch((err) => {
          console.log('** ERROR ** removeCoSecondaryUser respons (%j)', err)
          aStore.checkError(err)
          resolve({ success: false, error: true, errMsg: err })
        })
    }) // promise
  },
  setPrimaryUserData(user) {
    console.log('SET PRIMARY USER DATA (%j)', user)
    this.setPrimaryUser(user)
  },
  setPrimaryUser(user) {
    console.log('SET PRIMARY USER (%j)', user)
    this.primaryuser = {}
    this.primaryuser = user
    this.activeprimaryuser = user
  },
  async deleteRegularVisitorData(rvUser) {
    let { adminStore } = await import('@/stores/adminstore.js')
    return new Promise((resolve) => {
      let aStore = adminStore()
      let pUser = this.primaryuser
      console.log('primary user (%j)', pUser)
      console.log('RV user (%j)', rvUser)
      let deleteLoad =
        `<${rvUser.uid}> * * . \n` +
        `<${pUser.uid}> <pu_hasRegularVisitor> <${rvUser.uid}> . \n`
      let pLoad = {
        mutate: encodeLoad(deleteLoad),
        gogl: true
      }
      aStore
        .postHTTP('dgraph-api/ddeletenquad/regularvisitor', pLoad)
        .then((result) => {
          console.log('delete PRimary returned ', result)
          this.updatePrimaryUser().then(() => {
            resolve({
              success: true,
              data: result.data.dgraphresult
            })
          })
        })
        .catch((error) => {
          console.log('*** ERROR *** delete primary had some problems..')
          aStore.checkError(error)
          resolve({
            success: false,
            error: true,
            errorMsg: error.toString()
          })
        })
    }) // promise
  },
  async deletePrimaryUser(pUser) {
    console.log('DELET primary user (%s)', pUser.uid)
    /*
    @TODO sjekk for om bruker har data som kalender og faste besøkende bilder osv.
    Hvis så må det bekreftes at også disse også vil bli slettet.
    Hvis kun brukerdata - er det fritt frem foor å slette...
    */
    let { adminStore } = await import('@/stores/adminstore.js')
    return new Promise((resolve) => {
      let aStore = adminStore()
      let sUser = this.secondaryuser
      let deleteLoad =
        `<${pUser.uid}> * * . \n` +
        `<${sUser.uid}> <su_hasPrimaryUser> <${pUser.uid}> . \n`
      let pLoad = {
        mutate: encodeLoad(deleteLoad),
        gogl: true
      }
      aStore
        .postHTTP('dgraph-api/ddeletenquad/primaryuser', pLoad)
        .then((result) => {
          console.log('delete PRimary returned ', result)
          this.updatePrimaryUser().then(() => {
            resolve({
              success: true,
              data: result.data.dgraphresult
            })
          })
        })
        .catch((error) => {
          console.log('*** ERROR *** delete primary had some problems..')
          aStore.checkError(error)
          resolve({
            success: false,
            error: true,
            errorMsg: error.toString()
          })
        })
    }) // promise
  },
  async getPrimaryUser() {
    console.log('getPrimaryUser user got called (%s)', this.email)
    let secondaryUser = this.secondaryuser
    console.log('secondaryUser (%j)', secondaryUser)
    console.log('this email: (%j)', this.email)
    // let email = secondaryUser.su_email
    let { adminStore } = await import('@/stores/adminstore.js')
    let aStore = adminStore()
    aStore.setTest('GET PRIMARY USER')
    if (secondaryUser.su_hasPrimaryUser || false) {
      let query = `{
          var(func: eq(su_email,"${this.email}")) {
             su_hasPrimaryUser {
              pUid as uid
             }
          }
          query(func: uid(pUid)) {
            uid
            pu_name
            pu_displayName
            pu_service
            pu_image
            pu_email
            pu_phone
            pu_skype
            pu_picture
            pu_postcode
            pu_address
            pu_place
            pu_country
            pu_language
            pu_audio_speed
            pu_audio_pitch
            pu_audio_gender
            pu_created
            pu_userid
            pu_memas_login_code
            pu_showSurveyRationale
            pu_hasCalendar {
              uid
            }
            pu_hasRegularVisitor {
              uid
              rv_name
              rv_phone
              rv_image
            }
            pu_hasServices {
              uid
              service_title
              service_id
              service_visible
            }
            pu_hasDiagnose {
              uid
              diagnosis_title
              diagnosis_language
              diagnosis_purpose
              diagnosis_created
              diagnosis_updated
            }
           pu_hasLearningResourceVideo {
              uid
              lrv_title
              lrv_category
              lrv_duration
              lrv_website
              lrv_vimeoid
           }
          }
      } `
      let pLoad = {
        query: encodeLoad(query),
        gogl: true
      }

      console.log(query)
      return new Promise((resolve) => {
        aStore
          .postHTTP('dgraph-api/dquery/primaryUsers', pLoad)
          .then((response) => {
            console.log(response)
            let responseData = response.data
            console.log(
              'get primary user respons (%j)',
              responseData.dgraphresult
            )
            let primaryUsers = responseData.dgraphresult || []
            if (primaryUsers.length === 1) {
              this.setPrimaryUser(primaryUsers[0])
            }
            resolve({ success: true, data: primaryUsers })
          }) // then
          .catch((err) => {
            console.log('** ERROR ** getPrimaryUser respons (%j)', err)
            aStore.checkError(err)
            resolve({
              success: false,
              error: true,
              errMsg: err
            })
          }) // catch
      }) // promise
    } else {
      console.log('GOT ELSE - NO EXISTING PRIMARY USER')
      return { success: true, data: [] }
    }
  },
  async updatePrimaryUser() {
    console.log('updatePrimaryUser user got called (%s)', this.primaryuser.uid)
    let pUser = this.primaryuser
    let { adminStore } = await import('@/stores/adminstore.js')
    // console.log(secondaryUser)
    return new Promise((resolve) => {
      let aStore = adminStore()
      let query = `{
          query(func: uid(${pUser.uid})) {
            uid
            pu_name
            pu_displayName
            pu_service
            pu_image
            pu_email
            pu_phone
            pu_skype
            pu_picture
            pu_postcode
            pu_address
            pu_place
            pu_country
            pu_language
            pu_audio_speed
            pu_audio_pitch
            pu_audio_gender
            pu_created
            pu_userid
            pu_memas_login_code
            pu_showSurveyRationale
            pu_hasCalendar {
              uid
            }
            pu_hasRegularVisitor {
              uid
              rv_name
              rv_phone
              rv_image
            }
            pu_hasServices {
              uid
              service_title
              service_id
              service_visible
            }
            pu_hasDiagnose {
              uid
              diagnosis_title
              diagnosis_language
              diagnosis_purpose
              diagnosis_created
              diagnosis_updated
            }
            pu_hasLearningResourceVideo {
              uid
              lrv_title
              lrv_category
              lrv_duration
              lrv_website
              lrv_vimeoid
           }
          }
      } `
      let pLoad = {
        query: encodeLoad(query),
        gogl: true
      }
      console.log(query)
      aStore
        .postHTTP('dgraph-api/dquery/updatePrimaryUsers', pLoad)
        .then((response) => {
          console.log(response)
          let responseData = response.data
          console.log(
            'update primary user respons (%j)',
            responseData.dgraphresult
          )
          this.primaryuser = responseData.dgraphresult[0]
          resolve({ success: true, data: responseData.dgraphresult[0] })
        }) // then
        .catch((err) => {
          console.log('** ERROR ** updatePrimaryUser respons (%j)', err)
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // catch
    }) // promise
  },
  async NU_processJWT(token) {
    return new Promise((resolve) => {
      try {
        let jwtData = jwt.decode(token, { complete: true })
        if (!jwtData) {
          return resolve({
            success: false,
            error: true,
            errMsg: 'Invalid JWT token'
          })
        }
        console.log('----------------------')
        console.log('JWT TOKEN (%j)', jwtData)
        const payload = {
          userEmail: jwtData.payload.email,
          bearerToken: token,
          id_token: jwtData.signature,
          expires: jwtData.payload.exp,
          signedIn: jwtData.payload.email_verified,
          domain: jwtData.payload.hd,
          email: jwtData.payload.email,
          name: jwtData.payload.name,
          picture: jwtData.payload.picture,
          userid: jwtData.payload.email,
          userName: jwtData.payload.name
        }
        this.loginProviderLogin(payload).then((result) => {
          console.log('loginProviderLogin returned (%j)', result)
          resolve(result)
        })
      } catch (error) {
        resolve({ success: false, error: true, errMsg: error.message })
      }
    }) // promise
  },
  callback(payload) {
    return new Promise((resolve) => {
      try {
        let jwtData = jwt.decode(payload, { complete: true })

        if (!jwtData) {
          resolve({ success: false, error: true, errMsg: 'Invalid JWT token' })
          return
        }

        console.log('JWT DATA IS:', jwtData)
        resolve({ success: true, data: jwtData.payload })
      } catch (error) {
        resolve({ success: false, error: true, errMsg: error.message })
      }
    })
  },
  getRandomKey(numDigits) {
    let randomKey = ''
    let randomMax = randomDigits.length
    // console.log('RANDOM MAX IS (%s)', randomMax)
    if (numDigits) {
      for (let i = 0; i < numDigits; i++) {
        let random = Math.floor(Math.random() * randomMax)
        // console.log('RANDOM IS (%s) (%s)', random, randomDigits[random])
        randomKey = randomKey + randomDigits[random]
      }
    } else {
      randomKey = this.getRandomKey(4)
    }
    return randomKey
  },
  async saveSecondaryUser(payload) {
    console.log('saveSecondaryUser got called ', payload)
    let { adminStore } = await import('@/stores/adminstore.js')

    return new Promise((resolve) => {
      let aStore = adminStore()
      let pLoad = {
        mutate: encodeLoad(JSON.stringify(payload)),
        gogl: true
      }
      aStore
        .postHTTP('memas/saveSecondaryUser/newSecondaryUser', pLoad)
        .then((result) => {
          console.log('NEW/UPDATED Secondary User is returned(%j)', result)
          this.getSecondaryUser().then((res) => {
            console.log('GET SECONDARY USER RETURNED (%j)', res)
            resolve({ success: true })
          })
        })
        .catch((error) => {
          console.log('** ERROR ** saveSecondaryUser respons (%j)', error)
          aStore.checkError(error)
          resolve({
            success: false,
            error: true,
            errMsg: error
          })
        })
    }) // promise
  },
  async getSubscriptionModels() {
    console.log('getSubscriptionModels got called')
    let { adminStore } = await import('@/stores/adminstore.js')
    return new Promise((resolve) => {
      let aStore = adminStore()
      aStore
        .getHTTP('vipps/subscriptionModels')
        .then((result) => {
          resolve({ success: true, data: result.data.models })
        })
        .catch((err) => {
          console.log('** ERROR ** getSubscriptionModels respons (%j)', err)
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // catch
    }) // promise
  },
  async createSubscriptionAgreement(payload) {
    console.log('createSubscriptionAgreement got called (%j)', payload)
    let { adminStore } = await import('@/stores/adminstore.js')
    return new Promise((resolve) => {
      let aStore = adminStore()
      let pLoad = {
        mutate: encodeLoad(
          JSON.stringify({ uid: this.userid, planId: payload.planId })
        ),
        gogl: true
      }
      aStore
        .postHTTP('vipps/createAgreement/create', pLoad)
        .then((result) => {
          console.log('createSubscriptionAgreement respons (%j)', result)
          resolve({ success: true, data: result.data })
        })
        .catch((err) => {
          console.log(
            '** ERROR ** createSubscriptionAgreement respons (%j)',
            err
          )
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // catch
    }) // promise
  },
  async syncSubscriptionStatus(payload) {
    console.log('syncSubscriptionStatus got called (%j)', payload)
    let { adminStore } = await import('@/stores/adminstore.js')
    return new Promise((resolve) => {
      let aStore = adminStore()
      let uid = payload?.uid || this.userid
      let pLoad = {
        mutate: encodeLoad(JSON.stringify({ uid })),
        gogl: true
      }
      aStore
        .postHTTP('vipps/agreementStatus/status', pLoad)
        .then((result) => {
          console.log('syncSubscriptionStatus respons (%j)', result)
          resolve({ success: true, data: result.data })
        })
        .catch((err) => {
          console.log('** ERROR ** syncSubscriptionStatus respons (%j)', err)
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // catch
    }) // promise
  },
  async cancelSubscriptionAgreement(payload) {
    console.log('cancelSubscriptionAgreement got called (%j)', payload)
    let { adminStore } = await import('@/stores/adminstore.js')
    return new Promise((resolve) => {
      let aStore = adminStore()
      let uid = payload?.uid || this.userid
      let pLoad = {
        mutate: encodeLoad(JSON.stringify({ uid })),
        gogl: true
      }
      aStore
        .postHTTP('vipps/cancelAgreement/cancel', pLoad)
        .then((result) => {
          console.log('cancelSubscriptionAgreement respons (%j)', result)
          resolve({ success: true, data: result.data })
        })
        .catch((err) => {
          console.log(
            '** ERROR ** cancelSubscriptionAgreement respons (%j)',
            err
          )
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // catch
    }) // promise
  },
  async savePrimaryUser(payload) {
    console.log('savePrimaryUser got called (%j)', payload)
    let secondaryUser = this.secondaryuser
    let { adminStore } = await import('@/stores/adminstore.js')
    return new Promise((resolve) => {
      let aStore = adminStore()
      payload.secondaryUserUID = secondaryUser.uid
      console.log(payload)
      let pLoad = {
        mutate: encodeLoad(JSON.stringify(payload)),
        gogl: true
      }
      aStore
        .postHTTP('memas/savePrimaryUser/newPrimaryUser', pLoad)
        .then((result) => {
          this.primaryuser = payload
          console.log('NEW Primary User is returned(%j)', result)
          resolve({ success: true })
        })
        .catch((err) => {
          console.log('** ERROR ** savePrimaryUser respons (%j)', err)
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // catch
    }) // promise
  },
  async saveRegularVisitor(payload) {
    console.log('saveRegularVisitor got called ')
    let { adminStore } = await import('@/stores/adminstore.js')
    return new Promise((resolve) => {
      let aStore = adminStore()
      console.log(payload)
      let pLoad = {
        mutate: encodeLoad(JSON.stringify(payload)),
        gogl: true
      }
      aStore
        .postHTTP('memas/saveRegularVisitor/newRegularVisitor', pLoad)
        .then((result) => {
          console.log('NEW saveRegularVisitor is returned(%j)', result)
          this.updatePrimaryUser().then((res) => {
            resolve({ success: true, msg: 'with updated primary user' })
          })
        })
        .catch((err) => {
          console.log('** ERROR ** saveRegularVisitor respons (%j)', err)
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // catch
    }) // promise
  },
  async saveUserServices(payload) {
    console.log('saveUserServices got called ')
    let { adminStore } = await import('@/stores/adminstore.js')
    return new Promise((resolve) => {
      let aStore = adminStore()
      let puser = this.primaryuser
      let load = {}
      load.puser = puser
      load.services = payload
      console.log(payload)
      let pLoad = {
        mutate: encodeLoad(JSON.stringify(load)),
        gogl: true
      }
      aStore
        .postHTTP('memas/saveUserServices/updateUserServices', pLoad)
        .then((result) => {
          console.log('NEW saveRegularVisitor is returned(%j)', result)
          this.updatePrimaryUser().then((res) => {
            resolve({ success: true, msg: 'with updated primary user' })
          })
        })
        .catch((err) => {
          console.log('** ERROR ** saveRegularVisitor respons (%j)', err)
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // catch
    }) // promise
  },
  async addAdditionalSecondaryUser(email) {
    let { adminStore } = await import('@/stores/adminstore.js')

    return new Promise((resolve) => {
      let payload = {
        secondaryUserEmail: email,
        primaryUserUid: this.primaryuser.uid
      }
      let aStore = adminStore()
      let pLoad = {
        mutate: encodeLoad(JSON.stringify(payload)),
        gogl: true
      }
      aStore
        .postHTTP(
          'memas/addAdditionalSecondaryUser/additionalSecondaryUser',
          pLoad
        )
        .then((result) => {
          console.log('addAdditionalSecondaryUser is returned(%j)', result)
          if (result.data.success) {
            resolve({ success: true })
          } else if (result.data.noresult) {
            resolve({ success: false, noresult: true })
          } else {
            resolve({ success: false, error: true })
          }
        })
        .catch((err) => {
          console.log(
            '** ERROR ** addAdditionalSecondaryUser respons (%j)',
            err
          )
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // catch
    })
  },
  async getAdditionalUsersForPrimary() {
    let { adminStore } = await import('@/stores/adminstore.js')
    let aStore = adminStore()
    return new Promise((resolve) => {
      let pUser = this.primaryuser
      let query = `{
        query(func: uid(${pUser.uid})) {
          uid
          secondaryUsers: ~su_hasPrimaryUser {
						uid
            su_name
            su_phone
            su_skype
            su_email
          }
         }
        }`
      let pLoad = {
        query: encodeLoad(query),
        gogl: true
      }
      console.log(query)
      aStore
        .postHTTP('dgraph-api/dquery/getAdditionalUsers', pLoad)
        .then((response) => {
          console.log(response)
          console.log(
            'getAdditionalUsersForPrimary respons (%j)',
            response.data
          )
          let responseData = response.data
          if (responseData.success) {
            let rData = responseData.dgraphresult[0] || {}
            resolve({ success: true, data: rData.secondaryUsers })
          } else {
            resolve({ success: false, error: true, errMsg: response })
          }
        }) // then
        .catch((err) => {
          console.log(
            '** ERROR ** getAdditionalUsersForPrimary respons (%j)',
            err
          )
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // catch
    }) // promise
  },
  async getEngageData(payload) {
    let { adminStore } = await import('@/stores/adminstore.js')
    console.log('getEngageData got called (%j)', payload)
    return new Promise((resolve) => {
      let aStore = adminStore()
      let pLoad = {
        mutate: encodeLoad(JSON.stringify(payload)),
        gogl: true
      }
      aStore
        .postHTTP('memas/getEngageId/engageEmail', pLoad)
        .then((result) => {
          console.log('getEngageData is returned(%j)', result)
          if (result.data.success) {
            resolve({ success: true, engageId: result.data.engageId })
          } else {
            resolve(result.data)
          }
        })
        .catch((err) => {
          console.log('** ERROR ** getEngageData respons (%j)', err)
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // catch
    }) // promise
  },
  async savePrimaryHelpVideo(payload) {
    let { adminStore } = await import('@/stores/adminstore.js')
    console.log('savePrimaryHelpVideo got called (%j)', payload)
    return new Promise((resolve) => {
      let aStore = adminStore()
      let pLoad = {
        mutate: encodeLoad(JSON.stringify(payload)),
        gogl: true
      }
      aStore
        .postHTTP('memas/savePrimaryHelpVideo/newHelpVideo', pLoad)
        .then((result) => {
          console.log('NEW savePrimaryHelpVideo is returned(%j)', result)
          this.updatePrimaryUser().then((res) => {
            resolve({
              success: true,
              msg: 'with updated primary help video user'
            })
          })
        })
        .catch((err) => {
          console.log('** ERROR ** savePrimaryHelpVideo respons (%j)', err)
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // catch
    }) // promise
  },
  async getPrimaryHelpVideos() {
    let { adminStore } = await import('@/stores/adminstore.js')
    console.log(
      'getPrimaryHelpVideos user got called (%s)',
      this.primaryuser.uid
    )
    let pUser = this.primaryuser
    // console.log(secondaryUser)
    return new Promise((resolve) => {
      let aStore = adminStore()
      let query = `{
        query(func: uid(${pUser.uid})) {
          uid
          dailyHelp: pu_hasDailyHelp {
            uid
            dh_title
            dh_video
            dh_videoimage
            dh_created
          }
        }
      } `
      let pLoad = {
        query: encodeLoad(query),
        gogl: true
      }
      console.log(query)
      aStore
        .postHTTP('dgraph-api/dquery/getPrimaryHelpVideos', pLoad)
        .then((response) => {
          console.log(response)
          let responseData = response.data
          console.log(
            'getPrimaryHelpVideos respons (%j)',
            responseData.dgraphresult
          )
          resolve({ success: true, data: responseData.dgraphresult })
        }) // then
        .catch((err) => {
          console.log('** ERROR ** getPrimaryHelpVideos respons (%j)', err)
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // catch
    }) // promise
  },
  async deletePrimaryHelpVideo(payload) {
    let { adminStore } = await import('@/stores/adminstore.js')
    console.log('delte Primary Help Video got called (%j)', payload)
    return new Promise((resolve) => {
      let aStore = adminStore()
      let pUser = this.primaryuser
      console.log('primary help Video (%j)', pUser)
      let deleteLoad =
        `<${payload.uid}> * * . \n` +
        `<${pUser.uid}> <pu_hasDailyHelp> <${payload.uid}> . \n`
      let pLoad = {
        mutate: encodeLoad(deleteLoad),
        gogl: true
      }
      aStore
        .postHTTP('dgraph-api/ddeletenquad/helpVideo', pLoad)
        .then((result) => {
          console.log('delete Help Video returned ', result)
          this.updatePrimaryUser().then(() => {
            resolve({
              success: true,
              data: result.data.dgraphresult
            })
          })
        })
        .catch((error) => {
          console.log('*** ERROR *** delete help video had some problems..')
          console.log(error)
          aStore.checkError(error)
          resolve({
            success: false,
            error: true,
            errorMsg: error.toString()
          })
        })
    }) // promise
  },
  async savePrimaryWorkVideo(payload) {
    let { adminStore } = await import('@/stores/adminstore.js')
    console.log('savePrimaryWorkVideo got called (%j)', payload)
    return new Promise((resolve) => {
      let aStore = adminStore()
      let pLoad = {
        mutate: encodeLoad(JSON.stringify(payload)),
        gogl: true
      }
      aStore
        .postHTTP('memas/savePrimaryWorkVideo/newWorkVideo', pLoad)
        .then((result) => {
          console.log('NEW savePrimaryWorkVideo is returned(%j)', result)
          this.updatePrimaryUser().then((res) => {
            resolve({
              success: true,
              msg: 'with updated primary work video user'
            })
          })
        })
        .catch((err) => {
          console.log('** ERROR ** savePrimaryWorkVideo respons (%j)', err)
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // catch
    }) // promise
  },
  async getPrimaryWorkVideos() {
    let { adminStore } = await import('@/stores/adminstore.js')
    console.log(
      'getPrimaryWorkVideos user got called (%s)',
      this.primaryuser.uid
    )
    let pUser = this.primaryuser
    // console.log(secondaryUser)
    return new Promise((resolve) => {
      let aStore = adminStore()
      let query = `{
        query(func: uid(${pUser.uid})) {
          uid
          dailyWork: pu_hasWorkHelp {
            uid
            dw_title
            dw_video
            dw_videoimage
            dw_created
          }
        }
      } `
      let pLoad = {
        query: encodeLoad(query),
        gogl: true
      }
      console.log(query)
      aStore
        .postHTTP('dgraph-api/dquery/getPrimaryWorkVideos', pLoad)
        .then((response) => {
          console.log(response)
          let responseData = response.data
          console.log(
            'getPrimaryWorkVideos respons (%j)',
            responseData.dgraphresult
          )
          resolve({ success: true, data: responseData.dgraphresult })
        }) // then
        .catch((err) => {
          console.log('** ERROR ** getPrimaryWorkVideos respons (%j)', err)
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // catch
    }) // promise
  },
  async deletePrimaryWorkVideo(payload) {
    let { adminStore } = await import('@/stores/adminstore.js')
    console.log('delete Primary Work Video got called (%j)', payload)
    return new Promise((resolve) => {
      let aStore = adminStore()
      let pUser = this.primaryuser
      console.log('primary work Video (%j)', pUser)
      let deleteLoad =
        `<${payload.uid}> * * . \n` +
        `<${pUser.uid}> <pu_hasWorkHelp> <${payload.uid}> . \n`
      let pLoad = {
        mutate: encodeLoad(deleteLoad),
        gogl: true
      }
      aStore
        .postHTTP('dgraph-api/ddeletenquad/workVideo', pLoad)
        .then((result) => {
          console.log('delete Work Video returned ', result)
          this.updatePrimaryUser().then(() => {
            resolve({
              success: true,
              data: result.data.dgraphresult
            })
          })
        })
        .catch((error) => {
          console.log('*** ERROR *** delete work video had some problems..')
          console.log(error)
          aStore.checkError(error)
          resolve({
            success: false,
            error: true,
            errorMsg: error.toString()
          })
        })
    }) // promise
  },

  async logoutUser() {
    let { adminStore } = await import('@/stores/adminstore.js')
    let aStore = adminStore()
    return new Promise((resolve) => {
      this.loggedin = false
      aStore.serveraccesstoken = ''
      aStore.accesstoken = ''
      this.displayname = ''
      this.userid = ''
      this.idtoken = ''
      this.accesstokenexpires
      this.email = ''
      this.primaryuser = {}
      this.secondaryuser = {}
      sessionStorage.clear()
      localStorage.clear()
      resolve({ success: true })
    }) // promise
  },
  async getSelfReports() {
    let { adminStore } = await import('@/stores/adminstore.js')

    let pUser = this.primaryuser
    console.log('getSelfReports user got called (%s)', pUser.pu_displayName)
    return new Promise((resolve) => {
      let pUid = pUser.uid
      let aStore = adminStore()
      let load = `{
        query(func: uid("${pUid}")) {
           uid
           pu_hasSelfReporting {
            sr_testType
            sr_testTime
            sr_questions {
              srq_question_number
              srq_value
              duration as srq_duration
            }
            totalDuration: sum(val(duration))
           }
        }
    } `
      let pLoad = {
        query: encodeLoad(load),
        gogl: true
      }
      aStore
        .postHTTP('dgraph-api/dquery/getSelfReports', pLoad)
        .then((response) => {
          console.log('getSelfReports respons (%j)', response.data)
          resolve({ success: true, data: response.data.dgraphresult[0] })
        }) // then
        .catch((err) => {
          console.log('** ERROR ** getSelfReports respons (%j)', err)
          aStore.checkError(err)
          resolve({
            success: false,
            error: true,
            errMsg: err
          })
        }) // catch
    }) // promise
  },
  getUserServices() {
    let pUser = this.primaryuser
    let services = pUser.pu_hasServices || []
    return services
  },
  async setEngageUser(payload) {
    let { adminStore } = await import('@/stores/adminstore.js')

    let aStore = adminStore()
    let locale = aStore.lang
    console.log('setEngageUser got called (%s) (%j)', locale, payload)
    let user = payload || {}
    let agreementType = user.su_agrementtype || []
    if (agreementType.length < 6) {
      this.engageuser = { engageuser: false }
    } else {
      console.log('ENGAGE USER (%j)', user)
      let agreementType = user.su_agrementtype
      let memasAgreement = agreementType.substring(0, 6)
      let engageLanguage = agreementType.substring(6, agreementType.length)
      console.log('memasAgreement (%s)  (%s)', memasAgreement, engageLanguage)
      let lang2Digit = get2DigitLangCodes(locale)
      let mAgreement = `${memasAgreement}${lang2Digit}`
      console.log(
        'mAgreement (%s) (%s)',
        mAgreement,
        memasAgreement.toUpperCase() === 'ENGAGE'
      )
      if (memasAgreement.toUpperCase() === 'ENGAGE') {
        this.engageuser = { engageuser: true, lang: engageLanguage }
      } else {
        this.engageuser = { engageuser: false }
      }
    }
  }
}

function get2DigitLangCodes(lang) {
  switch (lang) {
    case 'nb-NO':
    case 'nn-NO':
    case 'nb':
      return 'nb'
    case 'en-GB':
    case 'en-US':
    case 'en':
      return 'en'
    case 'it-IT':
    case 'it':
      return 'it'
    case 'ro-RO':
    case 'ro':
      return 'ro'
    case 'fr-FR':
    case 'fr':
      return 'fr'
    default:
      return 'nb'
  }
}

const randomDigits = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'J',
  'K',
  'L',
  'M',
  'N',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9'
]

async function createJwtTokenForClient(payload) {
  console.log('createJwtTokenForClient got called')
  let tokenPayload = {
    userid: payload.userid,
    username: payload.username,
    affiliation: payload.affilitation,
    idToken: payload.idToken, // || payload.accesstoken,
    email: payload.email || 'NO EMAIL'
  }
  let serverSession
  try {
    serverSession = await getServerSecret()
  } catch (error) {
    console.error(
      '*** ERROR *** problems getting the secret from the server : ' + error
    )
    throw {
      error: true,
      errorMsg:
        '*** ERROR *** problems getting the secret from the server : ' + error
    }
  }
  return signClientToken(tokenPayload, serverSession)
}

/* Encrypts and signs the client token for a server session ({sid, secret, publicKey})
   returned by /sysinfo/jwtsecret or /auth/google|microsoft. */
async function signClientToken(tokenPayload, serverSession) {
  let { adminStore } = await import('@/stores/adminstore.js')
  let aStore = adminStore()
  let { publicKey, secret, sid } = serverSession
  aStore.sid = sid
  tokenPayload.serverSecret = secret
  tokenPayload.sessionid = sid
  try {
    let hypJWE = new CreateHypatiaJWE(tokenPayload, secret, null, publicKey)
    await hypJWE.setUp()
    let encrypted = await hypJWE.encrypt(JSON.stringify(tokenPayload))
    let token = await hypJWE.sign({ cryptedPayload: encrypted }, secret)
    return {
      encryptedPayload: encrypted,
      accessToken: token,
      publicKey: publicKey,
      secret: secret,
      sid: sid
    }
  } catch (error) {
    console.error('*** ERROR *** problems encrypting the payload : ' + error)
    throw {
      error: true,
      errorMsg: '*** ERROR *** problems encrypting the payload : ' + error
    }
  }
}

async function getServerSecret() {
  // console.log('GET SERVER Secret GOT CALLED !')
  console.log('=== getServerSecret ')
  let { adminStore } = await import('@/stores/adminstore.js')
  return new Promise((resolve, reject) => {
    let aStore = adminStore()
    // let accessClientToken = context.getters.getIdToken
    // console.error('========= idToken !!: ' + accessClientToken)
    // let serverUrl = context.getters.getServerUrl // No context outside action-vuex-store context...
    aStore
      .getHTTP('sysinfo/jwtsecret')
      .then((result) => {
        console.log(
          'JwtSecret er: (' + JSON.stringify(result.data.secret) + ')'
        )
        console.log('getServerSecret returned (%J)', result)
        //  localStorage.setItem('hypsaserversecret', result.data.secret)
        console.log('publicKey: ' + result.data.publicKey)
        resolve(result.data) // {'secret': something }
      })
      .catch((error) => {
        console.error('*** ERROR *** getServerSECRET had some errors:', error)
        reject(
          new Error({
            error: error
          })
        )
      })
  }) // promise
}
